import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BaseRestService } from './base-rest.service';
import { IWorkflowActionList, WorkflowAction } from '../models/workflow-action';

@Injectable({ providedIn: 'root'})
export class WorkflowActionService extends BaseRestService<WorkflowAction, IWorkflowActionList>{

  constructor(http: HttpClient, protected router: Router) {
    super(WorkflowActionService, http, 'api/workflowactions', 'workflow action', router);

    // enable caching
    this.cacheEnabled = true;
  }
}
